/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { Action } from './ActionCard';

export const calculateProgress = (actions: Action[]): number => {
    if (actions.length === 0) {
        return 0;
    }
    const completedTasks = actions.filter(a => a.checked).length;
    return completedTasks / actions.length;
};

export const getCompletedTaskCount = (actions: Action[]): number => {
    return actions.filter(a => a.checked).length;
};

export const formatProgressMessage = (
    completedCount: number,
    totalCount: number,
    template: string
): string => {
    return template
        .replace('{0}', completedCount.toString())
        .replace('{1}', totalCount.toString());
};

export const getHeroKeyframe = (
    actionsLength: number,
    completedTasks: number
): string | null => {
    const THREE_ACTIONS = 3;
    const FOUR_ACTIONS = 4;

    switch (actionsLength) {
        case THREE_ACTIONS:
            return 'task0' + (completedTasks + 1);
        case FOUR_ACTIONS:
            return completedTasks === 0 ? 'fadeIn' : 'task0' + completedTasks;
        default:
            return completedTasks === 0 ? 'fadeIn' : 'task0' + completedTasks;
    }
};

export const areAllTasksCompleted = (actions: Action[]): boolean => {
    return actions.length > 0 && actions.every(a => a.checked);
};
